import Text from "@/components/common/Typography/Text"
import { useAirlines } from "@/hooks/flight/useAirlines"
import { TypeTourDetails } from "@/lib/redux/features/tour/types"
import { Col, Image, Row, theme } from "antd"
import _ from "lodash"
import { FC } from "react"
import { useTranslation } from "react-i18next"

type TourFlightProps = {
  segments: any[],
  index: number
}
const TourFlight: FC<TourFlightProps> = ({ segments, index }) => {
  const airlines = useAirlines()
  const token = theme.useToken().token
  const { t } = useTranslation()

  return (
    <>
      <Row>
        <Text>{t("common.date")} {index ? _.lowerFirst(t("common.return")) : _.lowerFirst(t("common.departure"))}: <Text strong>{(segments || [])[0]?.date}</Text></Text>
      </Row>
      {segments?.map((seg) => {
        const airline = airlines[seg.airline]
        return (
          <Row>
            <Col span={24}>
              <Row style={{ marginTop: '1rem' }}>
                <Col span={24}>
                  <Row justify='space-between'>
                    <Col>
                      {seg.startTime}
                    </Col>
                    <Col>
                      <Image
                        src={airline?.url}
                        height={"2rem"}
                        preview={false}
                      />
                    </Col>
                    <Col>
                      {seg.endTime}
                    </Col>
                  </Row>
                  <Row align='middle'>
                    <Col style={{ width: 6, height: 6, borderRadius: "50%", background: token.colorWarning }}></Col>
                    <Col flex={1} style={{ borderTop: `1px solid ${token.colorWarning}` }}></Col>
                    <Col style={{ width: 6, height: 6, borderRadius: "50%", background: token.colorWarning }}></Col>
                  </Row>
                  <Row justify='space-between'>
                    <Col>
                      {seg.startPoint}
                    </Col>
                    <Col>
                      {seg.endPoint}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        )
      })}
    </>
  )
}

export default TourFlight